export default {
    name: 'v5-icon-arrow-right',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M434.944 790.624l-45.248-45.248L623.04 512 389.664 278.624l45.248-45.248L713.568 512z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
